import { RAILWAY_CLI_VERSION } from '@cli-constants/tool-versions.js'
import { compareVersions } from '@cli-utils/version.js'

export function isCompatibleRailwayVersion(version: string): boolean {
  return version.startsWith('5.') && compareVersions(version, RAILWAY_CLI_VERSION) >= 0
}
